import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.66668 8.00002C8.66668 8.36822 8.36821 8.66669 8.00001 8.66669C7.63181 8.66669 7.33334 8.36822 7.33334 8.00002C7.33334 7.63182 7.63181 7.33335 8.00001 7.33335C8.36821 7.33335 8.66668 7.63182 8.66668 8.00002Z"
      fill="currentColor"
    />
    <path
      d="M8.66668 5.33335C8.66668 5.70154 8.36821 6.00002 8.00001 6.00002C7.63181 6.00002 7.33334 5.70154 7.33334 5.33335C7.33334 4.96517 7.63181 4.66669 8.00001 4.66669C8.36821 4.66669 8.66668 4.96517 8.66668 5.33335Z"
      fill="currentColor"
    />
    <path
      d="M8.66668 10.6667C8.66668 11.0349 8.36821 11.3334 8.00001 11.3334C7.63181 11.3334 7.33334 11.0349 7.33334 10.6667C7.33334 10.2985 7.63181 10 8.00001 10C8.36821 10 8.66668 10.2985 8.66668 10.6667Z"
      fill="currentColor"
    />
  </SvgIcon>
));
